<div class="flex flex-row w-full h-screen">
  <flx-nav-menu
    [items]="navMenuItems()"
    [userAccessRights]="userAccessRights()"
    [permissions]="permissions()"
    class="w-[290px] grow-0 shrink-0 shadow-[0_0_70px_0_rgba(22,52,98,0.05)]"
  >
    <div
      class="flex flex-col items-center gap-6 px-2 pt-10 pb-4"
      sidenavHeader
    >
      <div
        class="w-full flex justify-center items-center"
        data-testid="flowx-logo-btn"
      >
        <a
          [routerLink]="['/']"
          class="cursor-pointer"
        >
          <!-- Two <img> tags so the light variant disappears in dark
            mode and vice versa. Avoids a runtime swap that depends
            on injecting the theme service into this layout. The
            white asset already ships in assets/. -->
          <img
            class="w-44 block dark:hidden"
            alt="flowx logo"
            src="./assets/logo-big.svg"
          />
          <img
            class="w-44 hidden dark:block"
            alt="flowx logo"
            src="./assets/logo-white-big.svg"
          />
        </a>
      </div>

      @if (isOrganizationAdminWorkspace()) {
        <div class="flex items-center justify-center gap-2 w-52">
          <i
            class="ph ph-network flex items-center justify-center shrink-0 h-6 w-6 rounded-full bg-neutral-500 text-white"
          ></i>
          <div class="flex gap-0.5 text-xs overflow-hidden">
            <div class="font-semibold">Organization:</div>
            <div
              [pTooltip]="organizationCode"
              [showDelay]="TOOLTIP_DEFAULT_DELAY"
              class="truncate"
            >
              {{ organizationCode }}
            </div>
          </div>
        </div>
      } @else {
        <flx-workspaces-switch />
      }
    </div>
  </flx-nav-menu>

  <div class="main-container flex flex-row items-start w-full overflow-y-auto">
    <div class="flex flex-col w-full h-full p-10 overflow-y-auto">
      <div>
        @if (
          someComponentsAreDown() &&
          !platformStatusService.notificationDismissed() &&
          canReadPlatformStatus()
        ) {
          <flx-message
            class="mb-8 w-full bg-orange-50"
            type="warning"
            layout="row"
            display="border"
          >
            <div class="flex flex-row items-center w-full text-base">
              @if (someComponentsAreDown) {
                <div>{{ firstDownComponent() }} component is down. Check details</div>
              } @else {
                <div>Several components are down. Check details</div>
              }

              <a
                class="text-blue-500 ml-1"
                routerLink="platform-status"
              >
                here
              </a>
              <flx-icon
                (click)="platformStatusService.dismissNotification()"
                name="close"
                class="cursor-pointer w-4 h-4 ml-auto text-yellow-400"
              />
            </div>
          </flx-message>
        }
      </div>
      <router-outlet />
    </div>
  </div>
</div>
